import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../footer.css";

const LayoutFooter = ({ collapsed }) => {

    const year = new Date().getFullYear();

    return (

        <footer className="layout-footer-wrap ">

            <Container fluid>

                <Row className="justify-content-center">

                    <Col xs={12}>

                        <div
                            className={`layout-footer-content ${collapsed
                                ? "layout-footer-mini"
                                : "layout-footer-expanded"
                                }`}
                        >

                            <p className="layout-footer-text">

                                © {year} All Rights Reserved{" "}

                                with
                                <span className="layout-footer-heart">
                                    ❤
                                </span>

                                by{" "}

                                <span className="layout-footer-brand">
                                    Cashback Promotors & Developers
                                </span>

                            </p>

                        </div>

                    </Col>

                </Row>

            </Container>

        </footer>

    );

};

export default LayoutFooter;